import { render, staticRenderFns } from "./CompetitionChooseLesson.vue?vue&type=template&id=33efcd7d&scoped=true&"
import script from "./CompetitionChooseLesson.vue?vue&type=script&lang=js&"
export * from "./CompetitionChooseLesson.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionChooseLesson.vue?vue&type=style&index=0&id=33efcd7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33efcd7d",
  null
  
)

export default component.exports